import { render, staticRenderFns } from "./LeaseContractTermsTabScreen.vue?vue&type=template&id=6b0011e0&"
import script from "./LeaseContractTermsTabScreen.vue?vue&type=script&lang=js&"
export * from "./LeaseContractTermsTabScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbrown/projects/okinus/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b0011e0')) {
      api.createRecord('6b0011e0', component.options)
    } else {
      api.reload('6b0011e0', component.options)
    }
    module.hot.accept("./LeaseContractTermsTabScreen.vue?vue&type=template&id=6b0011e0&", function () {
      api.rerender('6b0011e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/features/leases/screens/LeaseDetailsScreen/LeaseContractTermsTabScreen.vue"
export default component.exports